<template lang="">
    
    <v-card class="my-5 py-5 px-2 text-right">
         <v-btn class="mb-10 mr-2" color="#5E50A1" style="color:#fff" @click="exportpdf()">EXPORT PDF</v-btn>
         <v-btn class="mb-10 mr-10" color="#5E50A1" style="color:#fff" @click="exportCSV()">EXPORT CSV</v-btn>
          <Tableau 
            :url="url"
            :width="width"     
            :height="800"
            ref="tableau">               
        </Tableau>
        <v-alert
        outlined
        v-show="show" 
        type="warning"
        prominent
        border="left"
        class="text-center mx-10"
      >
            Mohon Hubungi Tim Tech </v-alert>
      
    </v-card>      
       
      
</template>
<script>
import 'vue-tableau'
export default {
   props:['url'],

   data(){
    return{
          width:"100%", 
          viz:null,
          show:false      
        }
   },
   methods: {               
        initViz() {
            let viz = new tableau.Viz(this.$refs.tableau, this.url, this.options,this.height);
            
            return viz
        },
        exportpdf(){
            this.$refs.tableau.viz.showExportPDFDialog();
        },
        exportCSV(){
            this.$refs.tableau.viz.showExportCrossTabDialog();
        }
    },
    mounted(){
        if(this.url == null){
            this.show = true
        }
    }        
}
</script>
<style scoped>
    iframe {
    height: 100vh !important;
}
</style>